module.exports = "/images/menuwhite.svg";